export default __webpack_public_path__ + "static/media/kitty.accedcc7.png";